import { countries } from '../models/EnumEntity';
import { PaymentStates } from '../models/PaymentStates';

const vouchers = {
    FB: "B",
    FA: "A",
    CreditNoteB: "B",
    CreditNoteA: "A"
}

export class utils {
    static NonEmptyOrNull = (input) => {
        const entries = Object.entries(input) // 1️⃣
        const nonEmptyOrNull = entries
            .filter(([, val]) => val !== '')
            .filter(([, val]) => val !== '-1')
            .filter(([, val]) => val !== null)
            .filter(([, val]) => val !== undefined) // 2️⃣
        return Object.fromEntries(nonEmptyOrNull)
    }
    
    static GetQueryStringsFromObject (object) {
        const keys = Object.keys(object);
        return keys.map(k => this.ConvertValueToQueryString(k, object[k])).filter(v => v).join('&');
    }

    static ConvertValueToQueryString (key, value) {
        if (typeof (value) !== 'boolean' && (!value || !value.toString()))
            return "";

        if (Array.isArray(value))
            return value.map(v => `${key}=${encodeURI(v)}`).join("&");
        else
            return `${key}=${encodeURI(value)}`;
    }

    static GetParameterQueryString (searchParams) {
        const auxParamet = {}
    
        for (const pair of searchParams.entries()) {
            if (pair[1] === 'undefined' || pair[1] === undefined || pair[1] === '-1') continue;
            
            const value = pair[0] === 'branchCodes' ? pair[1] : this.ConvertValueToNumberOrString(pair[1]);
           
            if (value === undefined) continue;
            let aux = value;
    
            if (auxParamet[pair[0]]) {
                aux = Array.isArray(auxParamet[pair[0]]) && auxParamet[pair[0]].length > 0
                    ? [...new Set(auxParamet[pair[0]])].concat(value)
                    : [auxParamet[pair[0]], value];
            }
    
            auxParamet[pair[0]] = aux;
        }
    
        return auxParamet;
    }

    static ConvertValueToNumberOrString (value) {
        const hasAnyLetter = (/[a-zA-Z]/).test(value);
        if (hasAnyLetter) {
            return value ?? ''
        }

        return Number(value) || value;
    }

    static validateStringNullOrEmpty (value) {
        return !!(!value || value === "");
    }

    static titleCase (str) {
        return str.toLowerCase().split(' ').map(function (word) {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }

    static groupBy = (array = [], key) => {
        if (array.length === 0)
            return array;

        return array.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    static sum = (xs, key) =>
        xs.reduce((a, b) => a + b[key] || 0, 0);

    static selectMany = (xs, key) =>
        key
            ? xs?.reduce((a, b) => a.concat(b[key]), [])
            : xs?.reduce((a, b) => a.concat(b), []);

    static stableSort = (array, orderBy, order = 'asc') => {
        const descendingComparator = (a, b, orderBy) => {
            if (b[orderBy] < a[orderBy])
                return -1;

            if (b[orderBy] > a[orderBy])
                return 1;

            return 0;
        }

        const comparator = order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);

        return array
            .map((el, index) => [el, index])
            .sort((a, b) => comparator(a[0], b[0]) || a[1] - b[1])
            .map((el) => el[0]);
    }

    static zeroPad = (num, places) =>
        String(num).padStart(places, '0');

    static getCountry = (country) =>
        countries.find(e => e.value === country)?.label;

    static getDateNow = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = this.zeroPad(date.getMonth() + 1, 2);
        const day = this.zeroPad(date.getDate(), 2);

        return `${year}-${month}-${day}`
    }

    static formatDate = (date) =>
        (new Date(date)).toLocaleString();

    static formatShortDate = (date) => {
        const newDate = new Date(date);
        return newDate.toLocaleDateString();
    }

    static formatDateForPicker = (date, UTC = true) => {
        if (!date) return "";

        const newDate = UTC
            ? new Date(new Date(date) - 3600000 * 3)
            : new Date(date);

        return newDate.toISOString().slice(0, 10)
    }

    static convertUTCToArgentina = (utcDate) => {
        const date = new Date(utcDate);
        const argentinaTimeOffset = -3; // Argentina is UTC-3
        return  new Date(date.setHours(date.getHours() + argentinaTimeOffset));
      };

    static formatMoney = (value = 0.0, locale = 'de-DE', options = {}) =>
        value.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2, ...options })

    static formatVoucherNumber = (num) =>
        this.zeroPad(num, 8)

    static formatVoucher = (country, type, pv, num) => {
        if (country !== "AR") return num;

        const voucher = vouchers[type];
        const prefix = this.zeroPad(pv, 5)
        const number = this.zeroPad(num, 8);
        return `${voucher}-${prefix}-${number}`;
    }

    static formatFinalConsumerName = (name) =>
        name
            ? name
                .replace(/[^A-Za-z0-9\s\u00C0-\u00FF]/g, '')
                .replace(/\s+/g, ' ')
                .split(' ')
                .map(word => word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : '')
                .join(' ')
            : ''

    static formatCompanyName = (name) =>
        name
            ? name
                .replace(/[^A-Za-z0-9\s.\u00C0-\u00FF]/g, '')
                .replace(/\s+/g, ' ')
                .replace(/[.]+/g, '.')
                .split(' ')
                .map(word => word ? word[0].toUpperCase() + word.slice(1) : '')
                .join(' ')
            : ''

    static generateTxt = (filename, text) => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    static export = (blob, fileName = 'export') => {
        const url = window.URL.createObjectURL(blob);
        const element = document.createElement("a");
        element.style.display = "none";
        element.href = url;
        element.download = `${fileName}_${new Date().toISOString()}.xlsx`
        document.body.appendChild(element);
        element.click();
        window.URL.revokeObjectURL(url);
    }

    static ValidateValueIsString = (value) =>
        (/[a-zA-Z]/).test(value);

    static ValidateDecimalFormat = (value) =>
        (/^[0-9]*(\.[0-9]{0,6})?$/).test(value)

    static getInitials = (name) => {
        let initials = name.split(' ');

        if (initials.length > 1) {
            initials = initials.shift().charAt(0) + initials.pop().charAt(0);
        } else {
            initials = name.substring(0, 2);
        }

        return initials.toUpperCase();
    }

    static getValueWhitPath = (item, path) => {
        if (!item || !path) {
            return;
        }

        const keys = path.split('.');
        let values = item;

        for (let index = 0; index < keys.length; index++) {
            values = values[keys[index]];
            if (values === undefined || values === null)
                break;
        }

        return values;
    }

    static printTemplate = (template) => {
        if (template && template !== "") {
            const w = window.open();
            w.document.write(template);
            setTimeout(() => {
                w.window.print();
                w.document.close();
            }, 500);
        }
        return false;
    }

    static ConvertMegabytesToBites (megabytes) {
        return megabytes * 1024 * 1024;
    }

    static ValidateFile (file, fileLengh, permittedExtensions, permittedExtensionsMsg) {
        if (file == null)
            return "Debe enviar un archivo para poder subir";
        if (permittedExtensions && !permittedExtensions.includes(file.type.toLowerCase()))
            return "El archivo que intenta subir no tiene el formato permitido (" + permittedExtensionsMsg + ")";
        if (file.size >= this.ConvertMegabytesToBites(fileLengh))
            return "El tamaño del archivo que intenta subir no puede ser superior a " + fileLengh + "MB";
    }

    static downloadOnTxt (object, name = 'json-text.txt') {
        const jsonString = JSON.stringify(object, undefined, 2);
        const link = document.createElement('a');
        link.download = name;
        const blob = new Blob([jsonString], { type: 'text/plain' });
        link.href = window.URL.createObjectURL(blob);
        link.click();
    }

    static mapPayment = (sale) => sale?.payments
        ?.filter(p => p.state === PaymentStates.Initialized)
        .map(p => ({
            binNumber: p.binNumber,
            type: p.paymentMethodType,
            cardId: p.cardId,
            installmentId: p.installmentId,
            amount: p.amount,
            interest: p.interest,
            bankId: p.bankId,
            lastCardDigits: p.lastCardDigits,
            checkId: p.checkId,
            checkAmount: p.checkAmount
        })) || [];

    static mapTotalPayedAmount = (sale) => sale?.payments
        ?.filter(p => p.state === PaymentStates.Approved || p.state === PaymentStates.PartiallyRefunded)
        .reduce((acum, curr) => acum + curr.totalAmount, 0) || 0

    static validateMail = (email) =>
        !(new RegExp(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g).test(email));
}